import { createSharedStoreHook } from 'shared-store-hook';

export const useHeaderHeight = createSharedStoreHook();
